import React from "react";
import { BadgeCheck } from "lucide-react";
import { fmtDate, EMDASH } from "./statFormat";

export default function TrustStrip({ trust, className = "" }) {
  if (!trust) return null;
  const dr = trust.date_range || {};
  return (
    <div
      data-testid="stats-trust-strip"
      className={`flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-slate-500 border-t border-slate-200 pt-3 ${className}`}
    >
      <span className="inline-flex items-center gap-1.5 font-semibold text-emerald-700">
        <BadgeCheck className="w-4 h-4" /> {trust.source || "Verified CBR Game Data"}
      </span>
      <span>{trust.games || 0} game{trust.games === 1 ? "" : "s"} included</span>
      {dr.from && (
        <span>
          {fmtDate(dr.from)}
          {dr.to && dr.to !== dr.from ? ` – ${fmtDate(dr.to)}` : ""}
        </span>
      )}
      {trust.opponents != null && <span>{trust.opponents} opponent{trust.opponents === 1 ? "" : "s"}</span>}
      {trust.last_updated && <span>Updated {fmtDate(trust.last_updated.slice(0, 10))}</span>}
    </div>
  );
}
